import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class WarehouseTransfers_ds_get_warehouse_transfer_line_by_lineNumber_warehouseTransferIdService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { warehouseTransferId: number, lineNumber: number }): 
  Promise<{ result: { OrderId?: number, LineNumber?: number, Order?: { LookupCode?: string, WarehouseTransfers?: { LookupCode?: string }[] } } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.warehouseTransferId)) {
      missingRequiredInParams.push('\'warehouseTransferId\'');
    }
    if (isNil(inParams.lineNumber)) {
      missingRequiredInParams.push('\'lineNumber\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/WarehouseTransfers/datasources/ds_get_warehouse_transfer_line_by_lineNumber_warehouseTransferId/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      warehouseTransferId: number, lineNumber: number    }) {
        if(isNil(inParams.warehouseTransferId)) {
          return true; 
        }
        if(isNil(inParams.lineNumber)) {
          return true; 
        }
      return false;
    }
}
